import { z } from "zod/v4";

export const AnalysisScoreTypeSchema = z.enum(["cp", "mate"]);
export type AnalysisScoreType = z.infer<typeof AnalysisScoreTypeSchema>;

export const ChessPiecesSchema = z.enum(["p", "n", "b", "r", "q", "k"]);
export type ChessPiece = z.infer<typeof ChessPiecesSchema>;

const chessPieceValueMap: Record<ChessPiece, number> = {
    p: 1,
    n: 3,
    b: 3,
    r: 5,
    q: 9,
    k: Infinity,
};

export const ChessPiece = {
    from: (value: ChessPiece) => value,
    parse: (value: string | undefined): ChessPiece | undefined => {
        const parsed = ChessPiecesSchema.safeParse(value);
        if (parsed.success) {
            return parsed.data;
        }
        return undefined;
    },
    value: (piece: ChessPiece): number => chessPieceValueMap[piece],
};

export const ChessColorsSchema = z.enum(["w", "b"]);
export type ChessColor = z.infer<typeof ChessColorsSchema>;
